// import { route } from "../Router";
import axios from "axios";
import formatNumber from "format-number";
import { allNavbarList } from "../components/Navbar/Sidebar";
import { chooseReportLabelListRND } from "../pages/ReportsNDocuments/constantRND";
import urls from "./urls";

export const groupByObj = (arr, property) => {
  return arr.reduce(function (memo, x) {
    if (!memo[x[property]]) {
      memo[x[property]] = [];
    }
    memo[x[property]].push(x);
    return memo;
  }, {});
};

export function getMonthFromString(mon) {
  var d = Date.parse(mon + "1, 2012");
  if (!isNaN(d)) {
    return new Date(d).getMonth() + 1;
  }
  return -1;
}
export const commonToast = {
  closeOnClick: true,
  autoClose: 3000,
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
};
export const reportListConverter = (
  selectedReports,
  allReportList = chooseReportLabelListRND
) => {
  if (selectedReports?.length > 0 && allReportList?.length > 0) {
    // const final = allReportList?.filter((data) =>
    //   selectedReports?.some((element) => data?.label === element?.rep_name)
    // );
    const final = allReportList
      ?.map((data) => {
        const isPresent = selectedReports?.some(
          (element) => data?.label === element?.rep_name
        );
        if (isPresent) {
          const report = selectedReports?.find(
            (element) => data?.label === element?.rep_name
          );
          const newdata = {
            ...data,
            report_id: report.rep_id,
          };
          return newdata;
        } else {
          return null;
        }
      })
      .filter((data) => data !== null);

    return final;
  } else {
    return [];
  }
};
export const routeListConverter = (role, selectRoleNavList, routeList) => {
  if (selectRoleNavList?.length > 0 && routeList?.length > 0) {
    if (role === "B") {
      selectRoleNavList = selectRoleNavList?.map((data) => {
        if (data === "Reports & Document") {
          data = "Reports & Documents";
        }
        return data;
      });
    }
    let updatedSelectedRoleNavList = [];
    if (role === "L") {
      updatedSelectedRoleNavList = [...selectRoleNavList, "DossDocs"];
    } else if (role === "V") {
      updatedSelectedRoleNavList = [...selectRoleNavList, "DossDocs"];
    } else {
      updatedSelectedRoleNavList = [...selectRoleNavList];
    }

    // const final = routeList?.filter((data) =>
    //   selectRoleNavList?.some((element) => data?.name === element)
    // );
    // return final;
    const final = routeList?.filter((data) =>
      updatedSelectedRoleNavList?.some((element) => data?.name === element)
    );
    return final;
  } else {
    return [];
  }
};
export const navListConverter = (
  role,
  selectRoleNavList,
  selectedRoleName = null,
  selectedDatabase = null,
  badgeCount,
  pendingAuthPayoffCount,
  pendingLenderApproval,
  allNavbar = allNavbarList(badgeCount, pendingAuthPayoffCount, pendingLenderApproval, role),
) => {
  if (selectRoleNavList?.length > 0 && allNavbar?.length > 0) {
    if (role === "B") {
      selectRoleNavList = selectRoleNavList?.map((data) => {
        if (data === "Reports & Document") {
          data = "Reports & Documents";
        }
        return data;
      });
    }
    let updatedSelectedRoleNavList = [];
    if (role === "L" || role === "L") {
      updatedSelectedRoleNavList = [
        ...selectRoleNavList,
        "Payoff Demands",
        "DossDocs",
      ];
    } else if (role === "V") {
      updatedSelectedRoleNavList = [...selectRoleNavList, "DossDocs"];
    } else if(role === "B"){
      updatedSelectedRoleNavList = [...selectRoleNavList, "Payoff Demands"];
    } else {
      updatedSelectedRoleNavList = [...selectRoleNavList];
    }

    let final = allNavbar?.filter((data) =>
      updatedSelectedRoleNavList?.some((element) => data?.name === element)
    );

    return final;
    // const final = allNavbar?.filter((data) =>
    //   selectRoleNavList?.some((element) => data?.name === element)
    // );
    // return final;
  } else {
    return [];
  }
};
export const stateCheck = (data) => (data === null ? [] : data);
export const createCopies = (n, obj) => {
  return Array.from({ length: n }, (obj2, index) => ({
    ...obj,
    principal: Math.random(obj.principal) * 10000,
    account: obj.account + index,
  }));
};
export const generateRandomColors = (count) => {
  const colors = [];
  const characters = "0123456789ABCDEF";

  for (let i = 0; i < count; i++) {
    let color = "#";
    for (let j = 0; j < 6; j++) {
      color += characters[Math.floor(Math.random() * 16)];
    }
    colors.push(color);
  }

  return colors;
};
export const generateRandomColors2 = (count) => {
  const colors = [];

  while (colors?.length < count) {
    const color = generateRandomColor();
    if (!colors.includes(color)) {
      colors.push(color);
    }
  }

  return colors;
};

function generateRandomColor() {
  const hue = Math.floor(Math.random() * 360);
  const saturation = Math.floor(Math.random() * 10) + 30;
  const lightness = Math.floor(Math.random() * 10) + 65;

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

export const imageTagToLink = (originalImgTag) => {
  const regex = /src="([^"]+)"/g;
  const baseUrl = "https://servicing.loans";
  const result = [];
  let match;
  while ((match = regex.exec(originalImgTag)) !== null) {
    result.push(baseUrl + match[1]);
  }

  return result;
};
export const formatDaysAgo = (days) => {
  const months = Math.floor(days / 30);
  const remainingDays = days % 30;

  let result = "";
  if (months > 0) {
    result += `${months} month${months > 1 ? "s" : ""} ago`;
  }

  if (remainingDays > 0) {
    if (months > 0) {
      result += ", ";
    }
    result += `${remainingDays} day${remainingDays > 1 ? "s" : ""} ago`;
  }

  return result;
};
export const numberToWords = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return "";
  }

  const belowTwenty = [
    "Zero",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const scales = [
    "",
    "Thousand",
    "Million",
    "Billion",
    "Trillion",
    "Quadrillion",
    "Quintillion",
    "Sextillion",
    "Septillion",
    "Octillion",
    "Nonillion",
    "Decillion",
  ];

  const convertHundreds = (num) => {
    let result = "";

    if (num >= 100) {
      result += belowTwenty[Math.floor(num / 100)] + " Hundred";
      num %= 100;

      if (num > 0) {
        result += " ";
      }
    }

    if (num >= 20) {
      result += tens[Math.floor(num / 10)];

      if (num % 10 > 0) {
        result += " " + belowTwenty[num % 10];
      }
    } else if (num > 0) {
      result += belowTwenty[num];
    }

    return result;
  };

  const convert = (num) => {
    if (num === 0) return "Zero";

    let words = "";
    let scaleIndex = 0;

    while (num > 0) {
      const chunk = num % 1000;

      if (chunk > 0) {
        const chunkWords = convertHundreds(chunk);

        words =
          chunkWords +
          (scales[scaleIndex] ? ` ${scales[scaleIndex]}` : "") +
          (words ? ` ${words}` : "");
      }

      num = Math.floor(num / 1000);
      scaleIndex++;
    }

    return words.trim();
  };

  const absoluteAmount = Math.abs(Number(amount));

  const dollars = Math.floor(absoluteAmount);
  const cents = Math.round((absoluteAmount - dollars) * 100);

  const dollarWords = convert(dollars);

  const formatted = `${dollarWords} Dollars and ${cents.toString().padStart(2, "0")}/100`;

  return amount < 0 ? `*** Negative ${formatted} ***` : `*** ${formatted} ***`;
};
export const updateLinkURL = (inputHTML) => {
  const oldPrefix = "/file/";
  const newPrefix = "https://servicing.loans/file2/";

  return inputHTML.replace(oldPrefix, newPrefix);
};
export const updateLinkURLNew = (inputHTML) => {
  const oldPrefix = "/file2/";
  const newPrefix = "https://servicing.loans/file2/";

  return inputHTML?.replace(oldPrefix, newPrefix);
};
export const removeSpanTag = (inputString) => {
  // Using a regular expression to remove the <span> tag
  const stringWithoutSpan = inputString?.replace(/<span.*?>|<\/span>/g, "");
  return stringWithoutSpan;
};
export const groupFunction = ({
  responseData,
  uniKeyToGroup,
  fieldsToAggregate,
  headerSet = null,
  headerCount = "account",
}) => {
  const groupedByCheckNo = {};

  responseData?.forEach((row) => {
    const keyValue = row?.[uniKeyToGroup];

    // Initialize group if it doesn't exist
    if (!groupedByCheckNo?.[keyValue]) {
      groupedByCheckNo[keyValue] = { ...{ ...row }, subRows: [] };
      fieldsToAggregate?.forEach((field) => {
        groupedByCheckNo[keyValue][field] = 0; // Initialize fields to aggregate
      });
    }

    // Aggregate specified fields
    fieldsToAggregate?.forEach((field) => {
      groupedByCheckNo[keyValue][field] += row?.[field];
    });

    // Add the current row as a sub-row
    groupedByCheckNo?.[keyValue]?.subRows?.push(row);
  });

  // Process the grouped data
  return Object.values(groupedByCheckNo).map((group) => {
    if (group.subRows?.length > 1) {
      // Replace 'account' with the count of subRows
      if (headerCount) {
        group[headerCount] = `${group?.subRows?.length || 0} - Accounts`;
      }
      if (headerSet) {
        Object.keys(headerSet)?.forEach((headerSetData) => {
          group[headerSetData] = headerSet[headerSetData];
        });
      }
    } else {
      // Remove unnecessary subRows array for single items
      delete group.subRows;
    }
    return group;
  });
};
export const reduceSum = (arr) => {
  return arr?.reduce((partialSum, a) => partialSum + a, 0);
};
export async function reduce_image_file_size(
  base64Str,
  MAX_WIDTH = 60,
  MAX_HEIGHT = 60
) {
  let resized_base64 = await new Promise((resolve) => {
    let img = new Image();
    img.src = base64Str;
    img.onload = () => {
      let canvas = document.createElement("canvas");
      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL()); // this will return base64 image results after resize
    };
  });
  return resized_base64;
}

export const convertList = (list) => {
  if (list?.length) {
    const final = list?.map(({ rep_name, sql_procedure_name, rep_id }) => ({
      // value: sql_procedure_name?.includes("LLQ_")
      //   ? sql_procedure_name?.replace("LLQ_", "")
      //   : sql_procedure_name,
      value: sql_procedure_name,
      label: rep_name,
      report_id: rep_id,
    }));
    return final;
  } else {
    return [];
  }
};

export function toTitleCase(str) {
  if (!str) return "";

  return str
    .split(" ") // Split the string into an array of words
    .map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize the first letter, and make the rest lowercase
    )
    .join(" "); // Join the words back into a single string
}

export const isProdEnvironment = () => {
  // Check if the current URL contains 'uat'
  return window.location.href.toLowerCase().includes("loanlinq.com");
};

export function formatNumbers(value) {
  return formatNumber({ prefix: "$", round: 2 })(
    parseFloat(value || 0).toFixed(2)
  );
}

const fetchAttachmentData = async (requestObj) => {
  const { databasename: type, FileNm: documentName } = requestObj;
  const basePaths = {
    ROC: "s3fs-private/Attachments_ROC/",
    SLS: "s3fs-private/Attachments/",
    CAP: "s3fs-private/Attachments_CAP/",
  };

  const documentPath = documentName
    ? basePaths[type] + documentName
    : basePaths[type] + requestObj?.filename;

  const data = JSON.stringify({
    bucketName: "tmo-attachments",
    documentPath: documentPath,
    database: type,
  });

  try {
    const response = await axios.post(urls.borrower.getAttachmentsUrl(), data, {
      headers: {
        "x-api-key": "12kXk3Xiou6Z50k0HSFZ5D8CScq2w6xJ",
        "Content-Type": "application/json",
      },
    });
    return response.data.presignedUrl;
  } catch (error) {
    console.error("Error fetching attachment data:", error);
    throw error;
  }
};

export default fetchAttachmentData;
